import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 h-full xl:h-screen w-full pt-6 xl:pt-[88px] pb-6 px-4" }
const _hoisted_2 = { class: "relative items-center md:hidden px-8" }
const _hoisted_3 = { class: "absolute left-0" }
const _hoisted_4 = { class: "text-2xl font-medium text-brown" }
const _hoisted_5 = { class: "text-left md:mx-auto py-6 px-4 md:px-10 bg-white rounded-[20px] flex flex-col items-center w-full md:max-w-[812px] h-full min-h-0 overflow-y-auto no-scrollbar" }
const _hoisted_6 = { class: "relative hidden md:flex justify-center items-center w-full min-h-11 mb-10" }
const _hoisted_7 = { class: "absolute left-0" }
const _hoisted_8 = { class: "text-2xl font-semibold text-brown" }

import CoinThrower from "@/views/Calculators/ICzinPrediction/components/CoinThrower.vue";
import ICzinFAQ from "@/views/Calculators/ICzinPrediction/components/ICzinFAQ.vue";
import PredictionResult from "@/views/Calculators/ICzinPrediction/components/PredictionResult.vue";
import { ref, onMounted } from "vue";
import { fetchICzinPredictions } from "@/api/calculators";
import { ICzinCoinState, ICzinResponse } from "@/types/calculators";
import BackButton from "@/components/buttons/BackButton.vue";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useSafeBack } from "@/utils/useSafeBack";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ICzinView',
  setup(__props) {

const { t } = useI18n();
const { safeBack } = useSafeBack();

const coins = ref<ICzinCoinState[]>([]);
const isFlipping = ref(false);
const flipResults = ref<number[]>([]);
const prediction = ref<ICzinResponse | null>(null);
const loadingApi = ref(false);

onMounted(() => {
  resetCoins();
});

function resetCoins() {
  coins.value = Array.from({ length: 3 }, () => {
    const side = randomSide();
    return {
      side,
      targetSide: side,
      angle: side === "eagle" ? 0 : 180,
    };
  });
  flipResults.value = [];
  loadingApi.value = false;
  prediction.value = null;
}

function randomSide() {
  return Math.random() < 0.5 ? "eagle" : "tails";
}

function flipAllCoins() {
  isFlipping.value = true;

  coins.value.forEach((coin, idx) => {
    coin.targetSide = randomSide();

    const isSame = coin.side === coin.targetSide;
    const rotations = isSame ? 2 : 3;

    const startAngle = coin.angle;
    const endAngle = startAngle + 180 * rotations;

    setTimeout(() => {
      coin.angle = endAngle;
      setTimeout(() => {
        coin.side = coin.targetSide;
        if (idx === coins.value.length - 1) {
          countResults();
          isFlipping.value = false;
        }
      }, 800);
    }, 100);
  });
}

async function countResults() {
  // 2 за орла, 3 за решку
  const sum = coins.value.reduce(
    (acc, coin) => acc + (coin.side === "eagle" ? 2 : 3),
    0
  );
  flipResults.value.push(sum);
  if (flipResults.value.length >= 6) {
    loadingApi.value = true;
    try {
      prediction.value = await fetchICzinPredictions(flipResults.value);
    } finally {
      loadingApi.value = false;
    }
  }
}

function handleBack() {
  if (prediction.value) {
    resetCoins();
    return;
  }
  safeBack(ROUTE_NAMES.TAROT);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BackButton, { onClicked: handleBack })
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)("calculators.iczin.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BackButton, { onClicked: handleBack })
        ]),
        _createElementVNode("h2", _hoisted_8, _toDisplayString(_unref(t)("calculators.iczin.title")), 1)
      ]),
      (!prediction.value)
        ? (_openBlock(), _createBlock(CoinThrower, {
            key: 0,
            coins: coins.value,
            results: flipResults.value,
            "is-flipping": isFlipping.value,
            "is-loading": loadingApi.value,
            onFlip: flipAllCoins
          }, null, 8, ["coins", "results", "is-flipping", "is-loading"]))
        : _createCommentVNode("", true),
      (!prediction.value)
        ? (_openBlock(), _createBlock(ICzinFAQ, { key: 1 }))
        : (_openBlock(), _createBlock(PredictionResult, {
            key: 2,
            results: flipResults.value,
            prediction: prediction.value,
            onReset: resetCoins
          }, null, 8, ["results", "prediction"]))
    ])
  ]))
}
}

})